import { PropType, reactive, ref } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';

type Props = SetupProps<typeof CarouselMarketingModuleSetupService.props>

export default class CarouselMarketingModuleSetupService extends BaseSetupService<Props> {
	static readonly props = {
		close: Boolean,
		title: {
			type: String,
			default: 'Renseignez un titre pour la card Marketing',
		},
		img: {
			type: String,
			default: 'history',
		},
		informationTooltip: {
			type: String,
			default: undefined,
		},
		settingType: {
			type: Number as PropType<SETTING_TYPE>,
			default: undefined,
		},
	};

	_preview = ref<HTMLElement>();
	_carousel?: OrionCarousel;

	private readonly state = reactive({ visible: false });

	order = {
		agencyCompanyContactDetailCity: 'COLMAR',
		agencyCompanyName: 'Agence Interim',
		city: 'Strasbourg',
		clientCompanyContactDetailCity: null,
		clientCompanyName: 'Entreprise Client',
		createdDate: new Date(),
		creatorUserUserType: 1,
		id: 1,
		histories: [
			{
				id: 129,
				createdDate: new Date(),
				type: 6,
				authorUser: {
					id: 2,
					firstName: 'Patrick',
					lastName: 'Schmidt',
					name: 'Patrick Schmidt',
					userType: 2,
					avatarId: null,
				},
				tempWorkerUser: {
					id: 7,
					firstName: 'Margot',
					lastName: 'Telier',
					name: 'Margot Telier',
					userType: 3,
					avatarId: null,
				},
			},
			{
				id: 12,
				createdDate: new Date(),
				type: 6,
				authorUser: {
					id: 2,
					firstName: 'Patrick',
					lastName: 'Schmidt',
					name: 'Patrick Schmidt',
					userType: 2,
					avatarId: null,
				},
				tempWorkerUser: {
					id: 7,
					firstName: 'Vladimir',
					lastName: 'Middon',
					name: 'Vladimir Middon',
					userType: 3,
					avatarId: null,
				},
			},
		],
		type: 1,
		start: '2022-01-18T07:00:00+00:00',
		startDate: '2022-01-18T07:00:00+00:00',
		candidatesWaitingResponses: [
			{
				status: 0,
				userAvatarId: null,
				userFirstName: 'Philippe',
				userId: 3,
				userLastName: 'Intérimaire',
				userName: 'Philippe Intérimaire',
			},
			{
				status: 0,
				userAvatarId: null,
				userFirstName: 'Philippe',
				userId: 9,
				userLastName: 'Intérimaire',
				userName: 'Philippe Intérimaire',
			},
		],
		candidatesWhoCanBeValidated: [],
		clientsWaitingResponses: [],
		professionalSkill: {
			code: '40309',
			id: 140,
			label: 'MONITEUR AUTO ECOLE',
		},
	} as unknown as IOrderDashboardItemModel;

	get visible () { return this.state.visible; }

	constructor (props: Props, _carousel?: OrionCarousel) {
		super(props);
		this._carousel = _carousel;
	}

	protected onMounted () {
		this.disableFocusInPreview();
		this._carousel?._el()?.querySelector('.order-dashboard-home-history-item')?.addEventListener('transitionend', () => {
			this._carousel?._el()?.classList.add('animation-loop');
		}, { once: true });

		setTimeout(() => {
			this.state.visible = true;
		}, 100);
	}

	async updateShowCardSettingAsync (value: boolean) {
		if (!this.props.settingType) return;
		await this.self.updateUserSettingAsync({
			settingType: this.props.settingType,
			value,
		});
		this.state.visible = false;
	}

	disableFocusInPreview () {
		const preview = this._preview.value;
		if (!preview) return;

		const inputNodes = preview.getElementsByTagName('INPUT') as HTMLCollectionOf<HTMLInputElement>;
		[...inputNodes].forEach(el => el.tabIndex = -1);

		const btnNodes = preview.getElementsByClassName('orion-button') as HTMLCollectionOf<HTMLElement>;
		[...btnNodes].forEach(el => el.tabIndex = -1);
	}

}
